const CompleteTaskRequest = function () {
  return {
    "taskId": "",
    "variables": []
  }
};

export default CompleteTaskRequest;



// WEBPACK FOOTER //
// ./src/service/request/CompleteTaskRequest.js